import { agent, API_MAP } from 'helpers';

import type { IAccessPolicyGroupList, IAccessPolicyPermissions, IAccessPolicySwitchAccount } from './interfaces';

export default class AccessPolicyService {
  static listAccounts() {
    return agent.get<IAccessPolicyGroupList>(API_MAP.accessPolicyAccesses);
  }

  static listGroups() {
    return agent.get<IAccessPolicyGroupList>(API_MAP.accessPolicyGroupList);
  }

  static switchAccount(email: string) {
    return agent.post<IAccessPolicySwitchAccount>(API_MAP.accessPolicySwitchAccount, { email });
  }

  static async getPermissions() {
    return agent.get<IAccessPolicyPermissions>(API_MAP.accessPolicyPermissions);
  }

  static deleteGroup(id: number) {
    return agent.del(API_MAP.accessPolicyGroupDelete.replace('{id}', id.toString()));
  }

  static listUsers() {
    return agent.get<IAccessPolicyGroupList>(API_MAP.accessPolicyUserList);
  }

  static deleteUser(id: number) {
    return agent.del(API_MAP.accessPolicyUserDelete.replace('{id}', id.toString()));
  }
}
